/* import React from 'react';

export default function Image(props) {
    const images = require.context('./../assets/images/', true);
    const imageName = props.img;
    let img = images('./' + imageName);

    return (<img src={img} alt={props.alt} className={props.className} />)
}
 */

import React from 'react';

export default function Image(props) {

    try { 
        let imgUrl = require(`./../assets/images/${props.img}`)
        return (<img 
            src={imgUrl} 
            alt={props.alt}
            className={props.className}
            />
        )
    } catch(e) { 
        console.error(e); 
        let imgUrl = require(`./../assets/images/image-broken.png`)
        return (<img 
            src={imgUrl} 
            alt={props.alt}
            className={props.className}
            />
        )
    }

}



